import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { FontsProvider } from "@/context/FontsContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import Brands from "@/pages/Brands";
import BrandDetail from "@/pages/BrandDetail";
import Templates from "@/pages/Templates";
import TemplateDetail from "@/pages/TemplateDetail";
import ColorCardDesigner from "@/pages/ColorCardDesigner";
import UploadExistingCard from "@/pages/UploadExistingCard";
import BatchColorCards from "@/pages/BatchColorCards";
import StandardColorCards from "@/pages/StandardColorCards";
import Drafts from "@/pages/Drafts";
import Help from "@/pages/Help";
import Settings from "@/pages/Settings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<FontsProvider><Layout /></FontsProvider>}>
                <Route index element={<Home />} />
                <Route path="/products" element={<Products />} />
                <Route path="/brands" element={<Brands />} />
                <Route path="/brands/:id" element={<BrandDetail />} />
                <Route path="/templates" element={<Templates />} />
                <Route path="/templates/:id" element={<TemplateDetail />} />
                <Route path="/designer" element={<ColorCardDesigner />} />
                <Route path="/designer/:id" element={<ColorCardDesigner />} />
                <Route path="/upload-existing" element={<UploadExistingCard />} />
                <Route path="/batch" element={<BatchColorCards />} />
                <Route path="/standard-cards" element={<StandardColorCards />} />
                <Route path="/drafts" element={<Drafts />} />
                <Route path="/help" element={<Help />} />
                <Route path="/settings" element={<Settings />} />
              </Route>
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
